import { render, staticRenderFns } from "./DialogAssignPurchases.vue?vue&type=template&id=b3aa1046&scoped=true&"
import script from "./DialogAssignPurchases.vue?vue&type=script&lang=js&"
export * from "./DialogAssignPurchases.vue?vue&type=script&lang=js&"
import style0 from "./DialogAssignPurchases.vue?vue&type=style&index=0&id=b3aa1046&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3aa1046",
  null
  
)

export default component.exports